import React from 'react';
import { contains } from 'ramda';
import { connect } from 'react-redux';
import { string, func, arrayOf } from 'prop-types';
import MenuItem from 'material-ui/MenuItem';

import DropDown from './DropDownTitled';
import { Timespan } from '../constants';
import { getSafeTimeBounds } from '../selectors/timeBounds';
import { getAvailableTimespans } from '../selectors/intervals';
import {
  timespanPresets,
  timespanPrecisionPresets,
} from '../utils/timePresets';
import { getCrimeType } from '../selectors/options';
import { timeIntervalPrecisionFormat } from '../utils/format';

export const TimespanSelector = ({
  labelColor,
  onChange,
  availableTimespans,
  timeBounds,
  value,
  crimeType,
  children,
  inDataSettings = false,
}) => {
  let timespans = [
    {
      value: Timespan.LAST_MONTH,
      text: 'Most Recent Month',
    },
    {
      value: Timespan.THIS_YEAR,
      text: 'Months This Year',
    },
    {
      value: Timespan.LAST_12_MONTHS,
      text: 'Last 12 Months',
    },
    {
      value: Timespan.LAST_YEAR,
      text: 'Last Year',
    },
    {
      value: Timespan.LAST_5_YEARS,
      text: 'Last 5 Years',
    },
  ];

  if (parseInt(crimeType, 10) === 1) {
    timespans.push(
      {
        value: Timespan.FROM_2010,
        text: '2010 – Last Year',
      },
      {
        value: Timespan.FROM_2000,
        text: '2000 – Last Year',
      },
      {
        value: Timespan.FROM_1990,
        text: '1990 – Last Year',
      },
    );
  }

  return (
    <DropDown
      value={value}
      title="Time Period:"
      labelStyle={{ color: labelColor }}
      style={{ width: '214px' }}
      iconStyle={{
        fill: inDataSettings
          ? 'rgba(0, 0, 0, .87)'
          : 'rgba(255, 255, 255, 0.93)',
      }}
    >
      {timespans.map(({ value, text }, i) => (
        <MenuItem
          key={i}
          value={value}
          disabled={!contains(value, availableTimespans)}
          primaryText={text}
          title={
            timeBounds
              ? timeIntervalPrecisionFormat[timespanPrecisionPresets[value]](
                  timespanPresets[value](timeBounds),
                )
              : null
          }
          onClick={() => onChange(value)}
        />
      ))}
      {children}
    </DropDown>
  );
};

TimespanSelector.propTypes = {
  value: string.isRequired,
  onChange: func.isRequired,
  timeBounds: string,
  availableTimespans: arrayOf(string).isRequired,
};

export default connect(state => ({
  crimeType: getCrimeType(state),
  timeBounds: getSafeTimeBounds(state),
  availableTimespans: getAvailableTimespans(state),
}))(TimespanSelector);



// WEBPACK FOOTER //
// ./src/components/TimespanSelector.jsx